import { MonacoLanguageDefinition } from '@theia-lved-core/types/monaco-language';
import * as monaco from '@theia/monaco-editor-core';

const configuration: monaco.languages.LanguageConfiguration = {
    brackets: [
        ['{', '}'],
        ['[', ']']
    ],
    autoClosingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '"', close: '"', notIn: ['string'] }
    ],
    surroundingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '"', close: '"' }
    ]
};

const language: monaco.languages.IMonarchLanguage = {
    tokenPostfix: '.json',
    keywords: ['true', 'false', 'null'],
    escapes: /\\(?:["\\\/bfnrt]|u[0-9A-Fa-f]{4})/,
    tokenizer: {
        root: [
            { include: '@whitespace' },
            [/[{}]/, '@brackets'],
            [/[\[\]]/, '@brackets'],
            [/,/, 'delimiter.comma'],
            [/:/, 'delimiter.colon'],
            [/"/, { token: 'string.key', next: '@stringKey' }],
            { include: '@value' }
        ],
        value: [
            { include: '@whitespace' },
            [/"/, { token: 'string', next: '@stringValue' }],
            [/-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?/, 'number'],
            [
                /\b(?:true|false|null)\b/,
                {
                    cases: {
                        '@keywords': 'keyword',
                        '@default': 'identifier'
                    }
                }
            ]
        ],
        stringKey: [
            [/[^\\"]+/, 'string.key'],
            [/@escapes/, 'string.escape'],
            [/\\./, 'string.escape.invalid'],
            [/"/, { token: 'string.key', next: '@pop' }]
        ],
        stringValue: [
            [/[^\\"]+/, 'string'],
            [/@escapes/, 'string.escape'],
            [/\\./, 'string.escape.invalid'],
            [/"/, { token: 'string', next: '@pop' }]
        ],
        whitespace: [[/[ \t\r\n]+/, 'white']]
    }
};

export const jsonLanguageDefinition: MonacoLanguageDefinition = {
    id: 'json',
    aliases: ['JSON', 'json'],
    extensions: ['.json'],
    filenames: ['.babelrc', '.eslintrc', '.prettierrc', '.stylelintrc'],
    configuration,
    language
};
